// meed/src/redux/errorMapping.ts

import { CSRF_FAILURE, RATE_LIMIT_FAILURE } from "./types";

export const ERROR_MAPPING: { [key: string]: string } = {
  "Invalid CSRF token. Session terminated.": CSRF_FAILURE,
  "Rate limit exceeded": RATE_LIMIT_FAILURE,
  // "Another error message": ANOTHER_FAILURE_TYPE,
  // ... add more error mappings as required
};